import gql from "graphql-tag";

const CHARGEBACK_FIELDS = gql`
  fragment ChargebackTransactionFields on ChargebackTransaction {
    id
    bookingId
    parkingAud
    overstayAud
    valetFeesAud
    totalAud
    currency
    status
    arrivedAt
    departedAt
    confirmedByName
    confirmedRole
    confirmedAt
    booking {
      id
      plate
      guestName
      guestRoom
      rateCard {
        id
        name
      }
    }
  }
`;

export const chargebackTransactionsQuery = gql`
  query ChargebackTransactions(
    $installationId: ID
    $status: ChargebackTransactionStatusEnum
    $from: DateTime
    $to: DateTime
    $confirmedById: ID
    $offset: Int
    $limit: Int
  ) {
    chargebackTransactions(
      installationId: $installationId
      status: $status
      from: $from
      to: $to
      confirmedById: $confirmedById
      offset: $offset
      limit: $limit
    ) {
      count
      totalAud
      currency
      items {
        ...ChargebackTransactionFields
      }
    }
  }
  ${CHARGEBACK_FIELDS}
`;

export const chargebackStaffQuery = gql`
  query ChargebackTransactionStaff($installationId: ID) {
    chargebackTransactionStaff(installationId: $installationId) {
      id
      name
    }
  }
`;

export const confirmChargebackTransactionMutation = gql`
  mutation ConfirmChargebackTransaction($id: ID!) {
    confirmChargebackTransaction(id: $id) {
      ...ChargebackTransactionFields
    }
  }
  ${CHARGEBACK_FIELDS}
`;
